import Vue from 'vue'
import VueRouter from 'vue-router'
import Cookies from 'js-cookie'
import { updateSeo } from '@/utils/seo'
import i18n, { supportedLocales } from '@/i18n'

Vue.use(VueRouter)

// 路由配置
const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Login/index.vue')
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('../views/Register/index.vue')
  },
  {
    path: '/pc-login',
    name: 'pcLogin',
    component: () => import('../views/PcGoogleLogin/index.vue')
  },
  {
    path: '/register-success',
    name: 'registerSuccess',
    component: () => import('../views/RegisterSuccess/index.vue')
  },
  {
    path: '/reset-password',
    name: 'resetPassword',
    component: () => import('../views/ResetPassword/index.vue')
  },
  {
    path: '/terms',
    name: 'terms',
    component: () => import('../views/Terms/index.vue')
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import('../views/Privacy/index.vue')
  },
  {
    path: '/message-test',
    name: 'messageTest',
    component: () => import('../views/MessageTest/index.vue')
  },
  {
    path: '/product',
    name: 'product',
    component: () => import('../views/Product/index.vue')
  },
  {
    path: '/product2',
    name: 'product2',
    component: () => import('../views/Product/index2.vue')
  },
  // 新手教程
  {
    path: '/tutorial',
    name: 'tutorial',
    component: () => import('../views/Tutorial/index.vue')
  },
  // 行业优势
  {
    path: '/advantage',
    name: 'advantage',
    component: () => import('../views/Advantage/index.vue')
  },
  // 用户实例
  {
    path: '/userInstance',
    name: 'userInstance',
    component: () => import('../views/UserInstance/index.vue')
  },
  // 产品方案
  {
    path: '/productScheme',
    name: 'productScheme',
    component: () => import('../views/ProductScheme/index.vue')
  },
  // 充值中心
  {
    path: '/pay',
    name: 'pay',
    component: () => import('../views/Pay/index.vue')
  },
  {
    path: '/account',
    name: 'account',
    component: () => import('../views/Account/index.vue')
  },
  // 退出登录
  {
    path: '/logout',
    name: 'logout',
    component: () => import('../views/Logout/index.vue')
  },
  // 关于我们
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/About/index.vue')
  },
  // 首页
  {
    path: '/home',
    name: 'home',
    component: () => import('../views/Home/index.vue')
  },
  // 根路径重定向到首页
  {
    path: '/',
    redirect: '/home'
  }
]

const router = new VueRouter({
  routes,
  mode: 'hash',
  // 添加滚动行为
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

router.beforeEach((to, from, next) => {
  const search = typeof window !== 'undefined' ? window.location.search || '' : ''
  const params = new URLSearchParams(search)

  // URL 指定语言（如外部引流链接 ?lang=en），优先级高于 localStorage 中的历史选择
  const queryLang = to.query.lang || params.get('lang')
  if (queryLang && supportedLocales.includes(queryLang) && i18n.locale !== queryLang) {
    i18n.setLocale(queryLang)
  }

  const ttclid = to.query.ttclid || params.get('ttclid') || undefined
  const querySource = to.query.source || to.query.utm_source || params.get('source') || params.get('utm_source') || (ttclid ? 'tiktok' : undefined)
  const cookieSource = Cookies.get('user_source') || undefined

  let source
  if (querySource) {
    source = querySource
  } else if (!cookieSource) {
    const ref = typeof document !== 'undefined' ? document.referrer || '' : ''
    if (/youtube\.com|youtu\.be/i.test(ref)) {
      source = 'youtube'
    } else if (/google\./i.test(ref)) {
      source = 'google'
    } else if (/tiktok\.com/i.test(ref)) {
      source = 'tiktok'
    }
  }

  if (source && source !== cookieSource) {
    Cookies.set('user_source', source, { expires: 30 })
  }

  next()
})

router.afterEach((to) => {
  if (typeof window !== 'undefined') {
    updateSeo(to)

    const page_path = to.fullPath
    const page_location = window.location.origin + '/#' + to.fullPath
    if (window.dataLayer && Array.isArray(window.dataLayer)) {
      window.dataLayer.push({
        event: 'page_view',
        page_path,
        page_location
      })
    }
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'page_view', {
        page_path,
        page_location
      })
    }
    if (to.path === '/advantage' && typeof window.gtag === 'function') {
      window.gtag('event', 'conversion', {
        send_to: 'AW-17392477726/kGI5CNLm8vcaEJ7MsOVA'
      })
    }
  }
})

export default router

// 重复跳转报错问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      throw err
    }
  })
}

// 重复替换报错问题
const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      throw err
    }
  })
}
